import { createContext } from 'react';

const RecipesContext = createContext();

export default RecipesContext;
